import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Img01 from '../images/balloonsodyssey/balloonsodyssey-store-05.png';


export default function BalloonsOdyssey_Store05() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: store stage boosts tab"
        description="Boosts you can buy ONLY during stage in Balloons Odyssey."
        images={[BalloonsOdyssey_Img01]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}